// extracted by mini-css-extract-plugin
export default {"td":"ContratosIndex_td__he020"};